import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import Categories from "./components/Categories";
import Featured from "./components/Featured";
import WhySection from "./components/WhySection";
import FaqSection from "./components/FaqSection";
import CtaBand from "./components/CtaBand";

const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "炮渣漫画网",
  url: "https://bencomic.github.io/",
  description: "无脑爽漫推荐、热血战斗排行、开挂主角漫画、逆袭流合集，龙傲天与打脸爽文漫一网打尽。",
  inLanguage: "zh-CN",
};

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    { "@type": "Question", name: "炮渣漫画网上的漫画可以免费阅读吗？", acceptedAnswer: { "@type": "Answer", text: "炮渣漫画网聚合当下热度最高的无脑爽漫与热血战斗作品，提供快速试读与榜单推荐服务，可查看完整简介、评分、热度与更新信息。如需完整章节，请前往对应漫画的正版平台支持作者。" } },
    { "@type": "Question", name: "热血战斗排行多久更新一次？", acceptedAnswer: { "@type": "Answer", text: "热血战斗排行每天自动更新一次，综合热度、评分、更新频率和读者反馈多个维度计算得出。" } },
    { "@type": "Question", name: "什么是龙傲天、逆袭流、打脸爽文？", acceptedAnswer: { "@type": "Answer", text: "龙傲天指主角天生无敌一路碾压的设定；逆袭流指主角从低谷一步步翻身逆袭；打脸爽文则是主角扮猪吃虎当众打脸反派的剧情。" } },
    { "@type": "Question", name: "如何找到适合我的漫画类型？", acceptedAnswer: { "@type": "Answer", text: "可通过顶部分类导航进入对应频道，也可在搜索框输入关键词快速定位，每个漫画卡片都标注了完整标签。" } },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />

      <Navbar />
      <main>
        <Hero />
        <RankingSection />
        <Categories />
        <Featured />
        <WhySection />
        <FaqSection />
        <CtaBand />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}